// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "1939cafa745916bbaa81608bb5bfb3344729c9ca/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};